import React from 'react'
import CountUp from 'react-countup'

const Counter = () => {
    return (
        <>
            {/* Counter Five*/}
            <section className="counter-section-five">
                <div className="container">
                    <div className="row align-items-center text-center justify-content-between">
                        {/* col */}
                        <div className="col-lg-3 col-md-3 col-sm-12" data-aos="fade-down">
                            <div className="count-five">
                                <div className="count-content-five course-count ms-0">
                                    <h4>
                                        <span className="counterUp"> <CountUp end={1} />M+</span>
                                    </h4>
                                    <p className="mb-0">Students Helped</p>
                                </div>
                            </div>
                        </div>
                        {/*/ col */}
                        {/* col */}
                        <div className="col-lg-3 col-md-3 col-sm-12" data-aos="fade-down">
                            <div className="count-five">
                                <div className="count-content-five course-count ms-0">
                                    <h4>
                                        <span className="counterUp"> <CountUp end={140000}/>+</span>
                                    </h4>
                                    <p className="mb-0">Global Programs</p>
                                </div>
                            </div>
                        </div>
                        {/*/ col */}
                        {/* col */}
                        <div className="col-lg-3 col-md-3 col-sm-12" data-aos="fade-down">
                            <div className="count-five">
                                <div className="count-content-five course-count ms-0">
                                    <h4>
                                        <span className="counterUp"><CountUp end={1500}/>+</span>
                                    </h4>
                                    <p className="mb-0">Institutions Globally</p>
                                </div>
                            </div>
                        </div>
                        {/*/ col */}
                        {/* col */}
                        <div className="col-lg-3 col-md-3 col-sm-12" data-aos="fade-down">
                            <div className="count-five count-five-last count-five-0">
                                <div className="count-content-five course-count ms-0">
                                    <h4>
                                        <span className="counterUp"><CountUp end={150}/>+</span>
                                    </h4>
                                    <p className="mb-0">Nationalities</p>
                                </div>
                            </div>
                        </div>
                        {/*/ col */}
                    </div>
                </div>
            </section>
            {/* /Counter Five*/}
        </>

    )
}

export default Counter
